import { jsx as p, Fragment as i } from "react/jsx-runtime";
import { Children as s, isValidElement as f } from "react";
const m = ({ children: o, invalidChildren: r = [] }) => {
  const n = s.toArray(o).filter((e) => {
    let t;
    return f(e) ? (typeof e.type == "string" ? t = e.type : typeof e.type == "object" && typeof e.type.displayName == "string" ? t = e.type.displayName : typeof e.type == "function" && (t = e.type.name), t && r.includes(t.toLowerCase()) ? (console.warn(
      `Filtering out ${t} because [${r.join(", ")}] are not allowed in this component.`
    ), !1) : !0) : !0;
  });
  return /* @__PURE__ */ p(i, { children: n });
};
export {
  m as ChildFilter
};
//# sourceMappingURL=index.js.map
